import Tooltip from './tooltip.js';

export default {
    init() {
        $.fn['tooltip'] = function() {
            return this.each((i, el) => {
                let tooltip = new Tooltip($(el));
                tooltip.init();
            });
        };

        $('[data-tooltip]')['tooltip']();

        $(document).on('enhance:ajaxload', 'footer', function () {
            $('[data-tooltip]')['tooltip']();
        });
    }
};
